exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header .navbar-brand .simple-svg {\n  max-width: 100%;\n}", ""]);

// exports
